(() => {
  if (customElements.get('pplpb-request-form')) return;
  const keys = ['open','chest','front','back','sleeve'];
  class RequestForm extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(this, {childList:true,subtree:true});
      this.addEventListener('submit', e => this.guard(e), true);
      this.addEventListener('click', e => { if (e.target.closest('button[type=submit],input[type=submit]')) this.guard(e); }, true);
      this.refresh();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    configure({phase,positions = [],project,valid = true,socks = false}) {
      this.phase = phase; this.positions = positions; this.project = project; this.valid = valid; this.socks = socks;
      this.dataset.phase = phase;
      return this.refresh();
    }
    hasFiles(key) {
      const group = this.querySelector('.ppq-upload-'+key);
      return !!group && (!!group.querySelector('.gfb__dropzone--preview--area')?.children.length || Array.from(group.querySelectorAll('input[type=file]')).some(i => i.files?.length));
    }
    refresh() {
      if (!this.phase) return false;
      for (const field of this.querySelectorAll('.globo-form-control')) {
        const upload = keys.find(k => field.classList.contains('ppq-upload-'+k));
        let visible = false;
        if (upload) {
          field.classList.remove('hidden');
          visible = this.socks ? upload === 'open' : this.phase === 'design' && (this.positions || []).includes(upload);
        } else if (!field.classList.contains('ppq-project-field')) {
          if (field.classList.contains('ppq-address')) field.classList.remove('hidden');
          visible = this.phase === 'contact';
        }
        field.hidden = !visible;
      }
      for (const row of this.querySelectorAll('.globo-form-row-item')) row.hidden = !Array.from(row.querySelectorAll('.globo-form-control')).some(f => !f.hidden);
      for (const row of this.querySelectorAll('.globo-form-row')) row.hidden = !Array.from(row.querySelectorAll('.globo-form-control')).some(f => !f.hidden);
      for (const part of this.querySelectorAll('.gfb__page-header,.gfb__page-footer,.wizard__header')) part.hidden = this.phase !== 'contact';
      for (const part of this.querySelectorAll('[data-contact-only]')) part.hidden = this.phase !== 'contact';
      const hint=this.querySelector('.gfb__page-header .globo-description');
      if(hint&&this.dataset.contactHint&&hint.textContent!==this.dataset.contactHint)hint.textContent=this.dataset.contactHint;
      const field = this.querySelector('.ppq-project-field textarea,textarea.ppq-project-field');
      if (!field || !this.project || (field.maxLength > 0 && this.project.length > field.maxLength)) return false;
      if (field.value !== this.project) {
        Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set.call(field, this.project);
        field.dispatchEvent(new Event('input', {bubbles:true}));
        field.dispatchEvent(new Event('change', {bubbles:true}));
      }
      field.readOnly = true;
      return field.value === this.project;
    }
    guard(e) {
      const preflight = new CustomEvent('pplpb:before-send', {bubbles:true,cancelable:true});
      const allowed = this.dispatchEvent(preflight);
      if (!allowed || this.phase !== 'contact' || !this.valid || !this.refresh()) {
        e.preventDefault(); e.stopImmediatePropagation();
        this.dispatchEvent(new CustomEvent('pplpb:form-blocked',{bubbles:true}));
      }
    }
  }
  customElements.define('pplpb-request-form',RequestForm);
})();
